/**
 * @fileoverview Reusable header component for help pages
 * 
 * This component provides a consistent header for all help pages with:
 * - Right side: Logo and "Spinner Games !!" text that links to main page
 * - Left side: "Back to App" button with icon
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface HelpPageHeaderProps {
  title?: string;
}

export const HelpPageHeader: React.FC<HelpPageHeaderProps> = ({ title }) => {
  return (
    <header className="bg-[#1e2434] shadow-[0px_4px_6px_#0000001a,0px_2px_4px_#0000001a] px-6 h-[54px] flex items-center">
      <div className="max-w-6xl mx-auto flex items-center justify-between w-full">
        {/* Left side - Logo and Brand Name */}
        <div className="flex items-center">
          <Link
            to="/"
            className="inline-flex items-center space-x-3 hover:opacity-80 transition-opacity"
          >
            <img
              src="/logo.png"
              alt="Spinner Games Logo"
              className="h-8 w-8 object-contain"
            />
            <span className="text-lg font-bold text-white">
              Spinner Games !!
            </span>
          </Link>
        </div>

        {/* Right side - Back to App button */}
        <div className="flex items-center">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white hover:text-gray-200 transition-colors rounded-lg hover:bg-gray-700"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to App
          </Link>
        </div>
      </div>
    </header>
  );
}; 